import { Box, Button, Modal, ModalClose, ModalDialog, Sheet, Textarea, Typography } from "@mui/joy";
import React from "react";

export interface ElevatorNotesDialogProps {
	open: boolean;
	onClose: () => void;
	elevatorId: string;
	elevatorSerialNumber: string;
	buildingName: string;
	initialNotes?: string;
	onSave: (elevatorId: string, notes: string) => void;
}

export default function ElevatorNotesDialog({
	open,
	onClose,
	elevatorId,
	elevatorSerialNumber,
	buildingName,
	initialNotes = "",
	onSave,
}: ElevatorNotesDialogProps) {
	const [notes, setNotes] = React.useState(initialNotes);
	const [isSaving, setIsSaving] = React.useState(false);

	// Reset notes when dialog opens with different elevator
	React.useEffect(() => {
		if (open) {
			setNotes(initialNotes || "");
		}
	}, [open, initialNotes]);

	const handleSave = async () => {
		setIsSaving(true);
		try {
			await onSave(elevatorId, notes);
			onClose();
		} catch (error) {
			console.error("Error saving elevator notes:", error);
		} finally {
			setIsSaving(false);
		}
	};

	const handleClose = () => {
		setNotes(initialNotes || ""); // Reset to original value
		onClose();
	};

	return (
		<Modal open={open} onClose={handleClose}>
			<ModalDialog sx={{ maxWidth: 500, width: "100%" }}>
				<ModalClose />
				<Typography level="title-lg" sx={{ marginBottom: 2 }}>
					Elevator Notes
				</Typography>
				
				<Typography level="body-sm" sx={{ marginBottom: 3 }}>
					<strong>Building:</strong> {buildingName}<br />
					<strong>Serial Number:</strong> {elevatorSerialNumber}
				</Typography>

				<Typography level="body-sm" sx={{ marginBottom: 1 }}>
					<strong>Notes:</strong>
				</Typography>
				<Textarea
					placeholder="Enter elevator notes here..."
					value={notes}
					onChange={(e) => setNotes(e.target.value)}
					minRows={4}
					maxRows={8}
					sx={{ marginBottom: 3 }}
				/>

				<Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
					<Button variant="plain" onClick={handleClose} disabled={isSaving}>
						Cancel
					</Button>
					<Button onClick={handleSave} loading={isSaving}>
						Save Notes
					</Button>
				</Box>
			</ModalDialog>
		</Modal>
	);
}
